export const modalContainerTheme = {
  bg: 'palette.black:0.5',
  container: {
    bg: 'palette.surface.5',
    borderColor: 'palette.transparent',
    borderRadius: '12px',
    borderWidth: '0px',
    boxShadow: 'palette.black:0.5',
  },
  footer: {
    borderColor: 'palette.neutral.20',
    borderWidth: '1px',
  },
  header: {
    borderColor: 'palette.transparent',
    borderWidth: '0px',
    title: 'palette.tertiary.90',
  },
};
